import React, { useState, useRef, forwardRef, useEffect, useImperativeHandle, useCallback, } from 'react';
import Dropdown from '../../UI/Dropdown/Dropdown';
import InputWrapperRefacture from '../../UI/Inputs/InputWrapperRefacture';
import { useTranslation } from 'react-i18next';
import ErrorBox from '../../UI/ErrorBox/ErrorBox';
import { format } from 'react-string-format';
import { APIGet } from '../../API/APIRequest';

export const County = forwardRef((props, ref) => {

    const { field,
        IsFilled,
        IsInvalid,
        selectedAddress,
        handleAddressInput,
        handleOnBlur,
        countryCode,
        countyCodeFromLoqate,
        editMode,
        setFieldsLoading,
        fieldsLoading,
        addressFormat } = props;

    const { t, i18n } = useTranslation();
    const [countyList, setCountyList] = useState("");
    const [matchNotFound, setMatchNotFound] = useState(false);


    const getCountyList = useCallback(() => {

        setFieldsLoading(true);
        return APIGet({
            "controller": "country",
            "action": "getcounties",
            "data": { "countryCode": countryCode },
            "environment": null,
            "identifier": null
        }).then((response) => {

            const counties = response.data.counties;
            setCountyList(counties);

          
            const willRenderDropdown = Array.isArray(counties) && counties.length > 0;
            if (addressFormat === "MANUAL" || !willRenderDropdown) {
                setFieldsLoading(false);
            }

        }).catch(() => {

            console.log("Issue fetching county list")
          
            setFieldsLoading(false);

        })
    }, [countryCode, addressFormat, setFieldsLoading]);

    useEffect(() => {

        getCountyList();

    }, []);

    const isInvalid = (((IsFilled[field.fieldName] && !IsFilled[field.fieldName]?.filled)) && field.mandatory) || (IsInvalid[field.fieldName] && IsInvalid[field.fieldName]?.invalid);

    const renderErrors = () => {
        return  <>
            {(((IsFilled[field.fieldName] && !IsFilled[field.fieldName]?.filled)) && field.mandatory) ? <span role="alert" id={`${[field.fieldName]}-errors`}> <ErrorBox>{format(t('addressfields.blankerrortext'), field.label)}</ErrorBox></span> : ""}
            {IsInvalid[field.fieldName]?.invalid ? <span role="alert" id={`${[field.fieldName]}-errors`}> <ErrorBox>{format(t('addressfields.errortext'), field.label)}</ErrorBox> </span> : ""}
            </>
    }

    return (
        <div className="item-container">
            <div className="item-wrapper">
               
                {(Array.isArray(countyList) && countyList.length > 0 && !matchNotFound) ?

                    <Dropdown setFieldsLoading={setFieldsLoading}
                        fieldLoading={fieldsLoading}
                        options={countyList}
                        optionName="countryname"
                        optionValue="countrycode"
                        optionId="countyid"
                        editMode={editMode}
                        preSelectedValue={countyCodeFromLoqate}
                        label={field.label}
                        id={field.fieldName + "dropdown"}
                        name={field.fieldName}
                        selectedOptionLabel={selectedAddress[field.fieldName]}
                        selectedOptionId={selectedAddress?.COUNTYUID}
                        inputSize="full-width"
                        invalidClass={isInvalid && "Invalid-input"}
                        ariaInvalid={isInvalid}
                        ariaDescribedby={`${[field?.fieldName]}-errors`}
                        selectItemInstructions={format(t("county.selectlabel"), field.label)}
                        handleOnBlur={(e) => handleOnBlur(e.target.value, [field.fieldName], field.mandatory)}
                        handleOnChange={(e) => handleAddressInput(e.target, [field.fieldName], field.mandatory, "countyDropdown")}
                        setMatchNotFound={setMatchNotFound}
                    />
                 :
                    <InputWrapperRefacture
                        label={field.label}
                        id={field.fieldName}
                        name={field.fieldName}
                        fieldLoading={fieldsLoading}
                        type="text"
                        inputFieldType="text"
                        placeholder={field.placeHolderText}
                        optionalField={!field.mandatory}
                        invalidClass={isInvalid && "Invalid-input"}
                        ariaInvalid={isInvalid}
                        aria-describedby={`${[field.fieldName]}-errors`}
                        inputSize="full-width"
                        value={selectedAddress[field.fieldName]}
                        onBlur={(e) => handleOnBlur(e.target.value, [field.fieldName], field.mandatory)}
                        onChange={(e) => handleAddressInput(e.target.value, [field.fieldName], field.mandatory)}
                    />
                }
                {renderErrors()}
            </div>
        </div>
    )
})